import { useState } from 'react';
import { axiosApi } from '../../api/setupApi';

const useAddCISBohol = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const addCISBohol = async (data) => {
    try {
      setLoading(true);
      try {
        const response = await axiosApi.post('/cisBohol/insert', data);
        if (response && (response.status === 200 || response.status === 201)) {
          setSuccess('CIS Bohol record successfully added!');
          setError(null);
          return { success: true, data: response.data };
        }
        setError(response.data?.message || 'Failed to add CIS Bohol record.');
        setSuccess(null);
        return { success: false, error: response.data?.message || 'Failed to add CIS Bohol record.' };
      } catch (err) {
        console.error('Error adding CIS Bohol record:', err);
        setError(err.response?.data?.message || 'An error occurred while adding CIS Bohol data.');
        setSuccess(null);
        return { success: false, error: err.response?.data?.message || 'An error occurred while adding CIS Bohol data.' };
      } finally {
        setLoading(false);
      }
    } catch (err) {
      console.error('Error adding CIS Bohol record:', err);
      setError('An error occurred while adding CIS Bohol data.');
      setSuccess(null);
      return { success: false, error: 'An error occurred while adding CIS Bohol data.' };
    } finally {
      setLoading(false);
    }
  };

  return { loading, success, error, setSuccess, setError, addCISBohol };
};

export default useAddCISBohol;
